<template>
  <div
    class="event-button-update"
    @click="update">
    クイズセットを更新
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    update: async function () {
      const result = await this.$store.dispatch('eventQuizset/save')
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.event-button-update {
  @include button-ol-warning;
}
</style>
